import { Route } from 'react-router-dom';
import {
  ContactPage,
  CourseProviders,
  FeaturePage,
  HospitalsAndTrusts,
  MarketingFeaturesIndex,
  MarketingLandingPage,
  TrustCentre,
  UniversitiesAndSocieties,
} from './MarketingPages';

export const getWebsiteMarketingRoutes = () => (
  <>
    <Route path="medical-education" element={<MarketingLandingPage />} />
    <Route path="hospitals-and-trusts" element={<HospitalsAndTrusts />} />
    <Route path="universities-and-societies" element={<UniversitiesAndSocieties />} />
    <Route path="course-and-cpd-providers" element={<CourseProviders />} />
    <Route path="features" element={<MarketingFeaturesIndex />} />
    <Route path="features/:slug" element={<FeaturePage />} />
    <Route path="trust-centre" element={<TrustCentre />} />
    <Route path="contact-us" element={<ContactPage />} />
  </>
);
